module.exports = __webpack_public_path__ + "ff721305bec9c4c78883212679be4582.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-21.png
// module id = 2149
// module chunks = 0